import { Navigate, Route } from "react-router-dom";
import { ReactNode } from "react";
import { AuthedApi } from "../../api/Api";
import { VoidAction } from "../../util/func";
import TopPageLayout from "./TopPage";

export type PageContext = {
  api: AuthedApi;
  update: VoidAction;
};

type Page = {
  name: string;
  path: string;
  main: (context: PageContext) => ReactNode;
};

export function GetRoutes(context: PageContext) {
  const pages: Page[] = [
    // 通常業務ページ
    { name: "リスト", path: "top/", main: (context) => <TopPageLayout pageContext={context} /> },

    // 業務管理ページ
  ]
  const routes = pages.map((page) => {
    return <Route key={page.path} path={page.path + "*"} element={page.main(context)}/>;
  });

  return [...routes, <Route key="default" path={"*"} element={<Navigate to="/system-admin/top/" replace />} />];
}
